import { EventSourceParserStream } from "eventsource-parser/stream";

// parse the sse stream for chat message responses
export async function* parseSSEStream(stream) {
  const sseStream = stream
    .pipeThrough(new TextDecoderStream())
    .pipeThrough(new EventSourceParserStream());

  for await (const chunk of sseStream) {
    console.log("CHUNK", chunk);

    if (chunk.event == "thread.message.delta") {
      yield {
        type: "message",
        data: chunk.data,
      };
    } else if (chunk.event == "query") {
      yield {
        type: "query",
        data: chunk.data,
      };
    } else if (chunk.type == "message") {
      yield {
        type: "message",
        data: chunk.data,
      };
    }
  }
}
